<template>
  <div class="homebox">
    <ul class="homebtn">
      <li><img src="@/assets/image/homebtn_qy.png"></li>
      <li><img src="@/assets/image/homebtn_gr.png"></li>
    </ul>
  </div>
</template>

<script>
export default {
  
}
</script>

<style src="@/assets/css/css.css" scoped></style>